/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { css, use, useClient, withMemo } from 'fierry/react';

import HexGeometry from 'solis/react/board/geometry/hex';
import ZoneGeometry from 'solis/react/board/geometry/zone';

import Background from 'solis/react/board/hex/background';
import Beacon from 'solis/react/board/hex/beacon';
import Borders from 'solis/react/board/hex/borders';
import Center from 'solis/react/board/hex/center';
import Lock from 'solis/react/board/hex/lock';

import Selection from 'solis/react/board/highlights/selection';


const DashedStyle = ({ borderGeometry }) => css`

  stroke-dasharray: ${borderGeometry.getDasharray(3)};
`;


const ExternalStyle = ({ hexGeometry, emphasized }) => css`

  stroke-width: ${emphasized ? hexGeometry.getEmphasizedBorderWidth() : hexGeometry.getExternalBorderWidth()};
`;


const TemporaryStyle = (props) => css`

  ${ExternalStyle(props)}
  ${DashedStyle(props)}
`;


const JaggedStyle = ({ hexGeometry }) => css`

  stroke-width: ${hexGeometry.getJaggedBorderWidth()};
`;


const GroupStyle = ({ hexGeometry, borderGeometry, groupEmphasized }) => css`

  ${DashedStyle({ borderGeometry })}

  stroke-width: ${groupEmphasized ? hexGeometry.getEmphasizedGroupBorderWidth() : hexGeometry.getGroupBorderWidth()};
`;


const ZoneStyle = ({ hexGeometry }) => css`

  stroke-width: ${hexGeometry.getZoneBorderWidth()};
`;


const Component = (props) =>
(
  <Center {...props}>

    <Background {...props} />

    <Borders {...props}
      externalStyle = {ExternalStyle}
      temporaryStyle = {TemporaryStyle}
      jaggedStyle = {JaggedStyle}
      groupStyle = {GroupStyle}
      zoneStyle = {ZoneStyle}
    />

    <Beacon {...props} value = {props.zoneData.getBeaconValue()} />
    <Lock {...props} />

    {props.selected && <Selection {...props} />}

  </Center>
);


export default withMemo(props =>
{
  const { zoneData } = props;

  const hexGeometry = use(HexGeometry);
  const zoneGeometry = useClient(ZoneGeometry, { zoneData, hexGeometry });

  return <Component {...props} hexGeometry = {hexGeometry} zoneGeometry = {zoneGeometry} />;
});
